export default __webpack_public_path__ + "static/media/thomas.ea87411d.jpg";